export default __webpack_public_path__ + "static/media/under_construction.f1434d13.svg";